import React, {useRef, useEffect, useState} from "react";
import {IEvent, IGame} from "@webng-types/write-model";
import {LiveblogEventRow} from "../LiveblogEventRow";
import { ChevronDown, ChevronsDown } from "react-feather";
import { useTranslation } from "react-i18next";
// import { Quote } from "@webng/icons-common";
import {useNavigateToEventId} from "../LiveblogRenderContext";

interface EventReferenceProps {
  game: IGame
  reference: IEvent;
  isPreview?: boolean
}

export function EventReference({isPreview, game, reference}: EventReferenceProps) {
  const wrapperRef = useRef<HTMLDivElement>(null);
  const outerWrapperRef = useRef<HTMLDivElement>(null);
  const timeoutRef = useRef<number>();
  const {t} = useTranslation("liveblog");
  const navigateToEvent = useNavigateToEventId();

  const [isHeightLimitActive, setIsHeightLimitActive] = useState(true) // height limit
  const [exceedsHeightLimit, setExceedsHeightLimit] = useState(false);

  useEffect(() => {
    if (!wrapperRef.current) return;
    if (!outerWrapperRef.current) return;

    const tik4Element = document.querySelector('.tik4');
    if (!tik4Element) return;

    const updateHeight = () => {
      if (wrapperRef.current) {
        const height = wrapperRef.current.offsetHeight;
        wrapperRef.current.parentElement?.parentElement?.style.setProperty('--t4-er-h', `${height}px`);

        // Get height limit from CSS variable from .tik4 element
        const heightLimit = parseInt(getComputedStyle(tik4Element).getPropertyValue('--t4-er-hlim')) || 600;
        setExceedsHeightLimit(height > heightLimit);
      }
    };

    const debouncedUpdate = () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      timeoutRef.current = window.setTimeout(updateHeight, 100);
    };

    // Watch for changes in the .tik4 element
    const outerWrapperResizeObserver = new ResizeObserver(debouncedUpdate);
    outerWrapperResizeObserver.observe(outerWrapperRef.current);

    // Watch for changes in the wrapper
    const wrapperResizeObserver = new ResizeObserver(debouncedUpdate);
    wrapperResizeObserver.observe(wrapperRef.current);

    // Initial height measurement
    updateHeight();

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      wrapperResizeObserver.disconnect();
      outerWrapperResizeObserver.disconnect();
    };
  }, []);

  return <div className={`tik4-er ${exceedsHeightLimit ? `tik4-er--hlim ${isHeightLimitActive ? 'tik4-er--hlim-active' : 'tik4-er--hlim-inactive'}` : ''}`}>
    <button className="tik4-er__l" onClick={() => navigateToEvent(reference.local_id!)}>
      <span className="tik4-er__l__t">{t('liveblog.event.reference.label')}</span>
      <ChevronsDown className="tik4-er__l__icon tik4-icon" />
    </button>
    <div className="tik4-er__ev">
      <div className="tik4-er__ow" ref={outerWrapperRef}>
        <div className="tik4-er__w" ref={wrapperRef}>
          <div className="tik4-er__c">
            <LiveblogEventRow game={game} event={reference} isPreview={isPreview} enableComments={false} isReference={true} />
          </div>
        </div>
      </div>
      {isHeightLimitActive && exceedsHeightLimit &&
        <div className="tik4-er__hlim">
          <button className="tik4-er__hlim__link tik4-link" onClick={() => setIsHeightLimitActive(false)}>
            <ChevronDown className="tik4-icon tik4-icon--mr"/>
            <span className="tik4-er__hlim__link__text">
              {t('liveblog.event.fold_out.button')}
            </span>
          </button>
        </div>
      }
    </div>
  </div>;
}
